import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography } from '@mui/material';

const BatchModalBody = ({ totalTimecardCount, totalHoursWorked }) => (
  <Box sx={{ width: '100%', justifyContent: 'space-between' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography>{LanguageConverterV2('timekeeping.modalBody.timecardCount')}</Typography>
      <Typography>{totalTimecardCount}</Typography>
    </Box>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography>{LanguageConverterV2('timekeeping.modalBody.totalHours')}</Typography>
      <Typography>{totalHoursWorked}</Typography>
    </Box>
  </Box>
);

export default BatchModalBody;

BatchModalBody.propTypes = {
  totalTimecardCount: PropTypes.number,
  totalHoursWorked: PropTypes.number,
};
